import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import * as CoreActions from '@core/core.actions';
import { selectSharepointTemplateExtraction, selectTemplateActualisation } from '@core/core.selectors';
import { TemplateActualisation } from '@core/core.state';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { selectPortalConfig } from '@platform/platform.selectors';
import { PortalConfig } from '@platform/platform.state';
import { filterSucceededResource, ResourceStatuses } from '@platform/shared/resource.state';
import { RootState } from '@root/app.state';
import { map } from 'rxjs';
import { AdminActionItemComponent } from '../ui/admin-action-item.component';
import { AdminPageSectionComponent } from '../ui/admin-page-section.component';
import { ButtonIndicatorComponent } from '../ui/button-indicator.component';

@Component({
  selector: 'app-update-template-section',
  imports: [TranslateModule, AdminPageSectionComponent, AdminActionItemComponent, DatePipe, ButtonIndicatorComponent],
  templateUrl: './update-template-section.component.html',
  styleUrl: './update-template-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None, // todo remove
})
export class UpdateTemplateSectionComponent {
  public readonly latestTemplateUpdates: Signal<TemplateActualisation | undefined>;
  public readonly extractPending: Signal<boolean>;
  public readonly portalConfig: Signal<PortalConfig | null | undefined>;

  constructor(private store$: Store<RootState>) {
    this.latestTemplateUpdates = toSignal(store$.pipe(select(selectTemplateActualisation), filterSucceededResource()));

    this.extractPending = toSignal(
      store$.pipe(
        select(selectSharepointTemplateExtraction),
        map((state) => state.status === ResourceStatuses.PENDING),
      ),
      { initialValue: false },
    );

    this.portalConfig = toSignal(store$.pipe(select(selectPortalConfig)));
  }

  public extractCustomerSpaceTemplate() {
    this.store$.dispatch(CoreActions.extractSharepointCustomerSpaceTemplate());
  }

  public extractProjectTemplate() {
    this.store$.dispatch(CoreActions.extractSharepointProjectTemplate());
  }
}
